import Vue from 'vue';
import { map } from 'lodash-es';
import * as C from '../../constants';

export default {

  /**
   *
   * @param state
   * @param payload
   */
  [C.SKI_STATE_RESET](state, payload) {
    Vue.set(state, 'areas', payload.areas);
    Vue.set(state, 'facts', payload.facts);
    Vue.set(state, 'area', payload.area);
  },

  /**
   * Alters the state indicating that the list of ski areas is pending.
   *
   * @param state
   */
  [C.SKI_AREAS_LIST_PENDING](state) {
    Vue.set(state, 'areas', {
      ...state.areas,
      loading: true,
      error: false,
    });
  },

  /**
   * Alters the state indicating the the list of ski areas has been fetched.
   *
   * @param state
   * @param payload
   */
  [C.SKI_AREAS_LIST_SUCCESS](state, payload) {
    Vue.set(state, 'areas', {
      ...state.areas,
      loading: false,
      error: false,
      items: payload,
    });
  },

  /**
   * Alters the state indicating that an error occurred while fetching the list of ski areas.
   *
   * @param state
   * @param payload
   */
  [C.SKI_AREAS_LIST_FAILURE](state, payload) {
    Vue.set(state, 'areas', {
      ...state.areas,
      loading: false,
      error: payload,
      items: null,
    });
  },

  /**
   * Alters the state indicating that the ski facts are being fetched
   *
   * @param state
   */
  [C.SKI_FACTS_GET_PENDING](state) {
    Vue.set(state, 'facts', {
      ...state.facts,
      loading: true,
      error: null,
    });
  },

  /**
   * Alters the state indicating that the ski facts have been fetched.
   *
   * @param state
   * @param payload
   */
  [C.SKI_FACTS_GET_SUCCESS](state, payload) {
    Vue.set(state, 'facts', {
      ...state.facts,
      loading: false,
      error: null,
      items: payload[0].data,
      units: payload[1].data,
      area: payload[2].data,
    });
    Vue.set(state, 'area', payload[2].data);
  },

  /**
   * Alters the state indicating that an error occurred while fetching the ski facts.
   *
   * @param state
   * @param payload
   */
  [C.SKI_FACTS_GET_FAILURE](state, payload) {
    Vue.set(state, 'facts', {
      ...state.facts,
      loading: false,
      error: payload,
      items: null,
    });
    Vue.set(state, 'area', null);
  },

  /**
   * Alters the state indicating that the ski facts are being updated.
   *
   * @param state
   */
  [C.SKI_FACTS_UPDATE_PENDING](state) {
    Vue.set(state, 'facts', {
      ...state.facts,
      loading: true,
      error: false,
    });
  },

  /**
   * Alters the state indicating that the ski facts have been updated.
   *
   * @param state
   */
  [C.SKI_FACTS_UPDATE_SUCCESS](state) {
    Vue.set(state, 'facts', {
      ...state.facts,
      loading: false,
      error: false,
    });
  },

  /**
   * Alters the state indicating that an error occurred while updating the ski facts.
   *
   * @param state
   * @param payload
   */
  [C.SKI_FACTS_UPDATE_FAILURE](state, payload) {
    Vue.set(state, 'facts', {
      ...state.facts,
      loading: false,
      error: payload,
    });
  },

  /**
   * Sets a new item
   *
   * @param state
   * @param index
   * @param payload
   */
  [C.SKI_FACT_SET](state, { index, payload }) {
    Vue.set(state.facts.items, index, {
      ...payload,
      value: isNaN(payload.value) ? null : payload.value,
      unit: typeof payload.unit === 'undefined' ? null : payload.unit,
    });
  },

  /**
   * Checks ski facts that have a value.
   *
   * @param state
   */
  [C.SKI_FACT_CHECK_VALUED](state) {
    Vue.set(state.facts, 'items', map(state.facts.items, item => ({
      ...item,
      show: !!item.value,
    })));
  },

  /**
   * Checks/un-checks all ski facts.
   *
   * @param state
   * @param payload
   */
  [C.SKI_FACT_CHECK_ALL](state, payload) {
    Vue.set(state.facts, 'items', map(state.facts.items, item => ({
      ...item,
      show: !!payload,
    })));
  },

  /**
   * Alters the state indicating that the snow guarantee info is being fetched
   *
   * @param state
   */
  [C.SKI_SNOW_GUARANTEE_GET_PENDING](state) {
    Vue.set(state, 'snowGuarantee', {
      ...state.snowGuarantee,
      loading: true,
      error: null,
    });
  },

  /**
   * Alters the state indicating that the snow guarantee info has been fetched.
   *
   * @param state
   * @param payload
   */
  [C.SKI_SNOW_GUARANTEE_GET_SUCCESS](state, payload) {
    Vue.set(state, 'snowGuarantee', {
      ...state.snowGuarantee,
      loading: false,
      error: null,
      active: payload[0].data.active,
      title: payload[0].data.title,
      description: payload[0].data.description,
    });
    Vue.set(state, 'area', payload[1].data);
  },

  /**
   * Alters the state indicating that an error occurred while fetching the snow guarantee info.
   *
   * @param state
   * @param payload
   */
  [C.SKI_SNOW_GUARANTEE_GET_FAILURE](state, payload) {
    Vue.set(state, 'snowGuarantee', {
      ...state.snowGuarantee,
      loading: false,
      error: payload,
      items: null,
    });
  },

  /**
   * Sets snow guarantee.
   *
   * @param state
   * @param payload
   */
  [C.SKI_SNOW_GUARANTEE_SET](state, payload) {
    Vue.set(state, 'snowGuarantee', {
      ...state.snowGuarantee,
      ...payload,
    });
  },

  /**
   * Alters the state indicating that the snow guarantee are being updated.
   *
   * @param state
   */
  [C.SKI_SNOW_GUARANTEE_UPDATE_PENDING](state) {
    Vue.set(state, 'snowGuarantee', {
      ...state.snowGuarantee,
      loading: true,
      error: false,
    });
  },

  /**
   * Alters the state indicating that the snow guarantee have been updated.
   *
   * @param state
   */
  [C.SKI_SNOW_GUARANTEE_UPDATE_SUCCESS](state) {
    Vue.set(state, 'snowGuarantee', {
      ...state.snowGuarantee,
      loading: false,
      error: false,
    });
  },

  /**
   * Alters the state indicating that an error occurred while updating the snow guarantee.
   *
   * @param state
   * @param payload
   */
  [C.SKI_SNOW_GUARANTEE_UPDATE_FAILURE](state, payload) {
    Vue.set(state, 'snowGuarantee', {
      ...state.snowGuarantee,
      loading: false,
      error: payload,
    });
  },

  /**
   * Alters the state indicating that the slope maps are being fetched.
   *
   * @param state
   */
  [C.SKI_SLOPE_MAPS_PENDING](state) {
    Vue.set(state, 'slopeMaps', {
      ...state.slopeMaps,
      loading: true,
      error: false,
      items: [],
    });
  },

  /**
   * Alters the state indicating that the slope maps was fetched successfully.
   *
   * @param state
   * @param payload
   */
  [C.SKI_SLOPE_MAPS_SUCCESS](state, payload) {
    Vue.set(state, 'slopeMaps', {
      ...state.slopeMaps,
      items: payload,
      loading: false,
      error: false,
    });
  },

  /**
   * Alters the state indicating that the slope maps was fetched unsuccessfully.
   *
   * @param state
   * @param payload
   */
  [C.SKI_SLOPE_MAPS_FAILURE](state) {
    Vue.set(state, 'slopeMaps', {
      ...state.slopeMaps,
      items: [],
      loading: false,
      error: true,
    });
  },

  /**
   * Set the area in state.
   *
   * @param state
   * @param payload
   */
  [C.SKI_AREA_SET](state, payload) {
    Vue.set(state, 'area', payload);
  },

  /**
   * Set the ski area to null.
   *
   * @param state
   */
  [C.SKI_AREA_PENDING](state) {
    Vue.set(state, 'area', null);
  },

  /**
   * Set the ski area to payload.
   *
   * @param state
   * @param payload
   */
  [C.SKI_AREA_SUCCESS](state, payload) {
    Vue.set(state, 'area', payload);
  },

  /**
   * Set the ski area to null.
   *
   * @param state
   */
  [C.SKI_AREA_FAILURE](state) {
    Vue.set(state, 'area', null);
  },

  /**
   * Indicates that the slope map is being uploaded.
   *
   * @param state
   */
  [C.SKI_SLOPE_MAP_ADD_PENDING](state) {
    Vue.set(state, 'slopeMap', {
      loading: true,
      error: false,
    });
  },

  /**
   * Indicates that the slope map was uploaded successfully.
   *
   * @param state
   * @param payload
   */
  [C.SKI_SLOPE_MAP_ADD_SUCCESS](state, payload) {
    state.slopeMaps.items.push(payload);
    Vue.set(state, 'slopeMap', {
      loading: false,
      error: false,
    });
  },

  /**
   * Indicates that the slope map was uploaded unsuccessfully.
   *
   * @param state
   */
  [C.SKI_SLOPE_MAP_ADD_FAILURE](state) {
    Vue.set(state, 'slopeMap', {
      loading: false,
      error: true,
    });
  },

  /**
   * Indicates that the slope maps is being removed.
   *
   * @param state
   */
  [C.SKI_SLOPE_MAP_REMOVE_PENDING](state) {
    Vue.set(state, 'slopeMap', {
      loading: true,
      error: false,
    });
  },

  /**
   * Indicates that the slope map was removed successfully.
   *
   * @param state
   * @param payload
   */
  [C.SKI_SLOPE_MAP_REMOVE_SUCCESS](state, payload) {
    Vue.set(state, 'slopeMaps', {
      items: payload,
    });
    Vue.set(state, 'slopeMap', {
      loading: false,
      error: false,
    });
  },

  /**
   * Indicates that the slope maps was removed unsuccessfully.
   *
   * @param state
   */
  [C.SKI_SLOPE_MAP_REMOVE_FAILURE](state) {
    Vue.set(state, 'slopeMap', {
      loading: false,
      error: true,
    });
  },

  /**
   * Indicates that the slope maps are being rearranged.
   *
   * @param state
   */
  [C.SKI_SLOPE_MAP_UPDATE_PENDING](state) {
    Vue.set(state, 'slopeMap', {
      loading: true,
      error: false,
    });
  },

  /**
   * Indicates that the slope maps was rearranged successfully.
   *
   * @param state
   * @param payload
   */
  [C.SKI_SLOPE_MAP_UPDATE_SUCCESS](state, payload) {
    Vue.set(state, 'slopeMaps', {
      items: payload,
    });
    Vue.set(state, 'slopeMap', {
      loading: false,
      error: false,
    });
  },

  /**
   * Indicates that the slope maps was rearranged unsuccessfully.
   *
   * @param state
   */
  [C.SKI_SLOPE_MAP_UPDATE_FAILURE](state) {
    Vue.set(state, 'slopeMap', {
      loading: false,
      error: true,
    });
  },

  /**
   * Load pickup places pending
   *
   * @param state
   */
  [C.SKI_PICKUP_PLACES_GET_PENDING](state) {
    Vue.set(state, 'pickupPlaces', {
      items: [],
      loading: true,
      error: false,
    });
  },

  /**
   * Load pickup places success
   *
   * @param state
   * @param payload
   */
  [C.SKI_PICKUP_PLACES_GET_SUCCESS](state, payload) {
    Vue.set(state, 'pickupPlaces', {
      items: payload,
      loading: false,
      error: false,
    });
  },

  /**
   * Load pickup places failure
   *
   * @param state
   */
  [C.SKI_PICKUP_PLACES_GET_FAILURE](state) {
    Vue.set(state, 'pickupPlaces', {
      items: [],
      loading: false,
      error: true,
    });
  },

  /**
   * Update pickup places failure
   *
   * @param state
   */
  [C.SKI_PICKUP_PLACES_UPDATE_PENDING](state) {
    Vue.set(state, 'pickupPlaces', {
      items: [],
      loading: true,
      error: false,
    });
  },

  /**
   * Update pickup places success
   *
   * @param state
   */
  [C.SKI_PICKUP_PLACES_UPDATE_SUCCESS](state, payload) {
    Vue.set(state, 'pickupPlaces', {
      items: payload,
      loading: false,
      error: false,
    });
  },

  /**
   * Update pickup places failure
   *
   * @param state
   * @param payload
   */
  [C.SKI_PICKUP_PLACES_UPDATE_FAILURE](state) {
    Vue.set(state, 'pickupPlaces', {
      items: [],
      loading: false,
      error: true,
    });
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/ski/areas/mutations.js